import { DEADLINE_LABEL } from '@witmetrics/utils/constants';

export const DEADLINE_KEYS = new Set(Object.keys(DEADLINE_LABEL));
